export default {
  get(state) {
    console.log("get securepay response", state.data);
    return state.data;
  },
  paymentType(state, getters) {
    const response = getters["get"];
    if ("cardtype" in response) {
      return response["cardtype"].toLowerCase();
    }
    return "";
  },
};
